export default "__VITE_ASSET__vK0a_Sc0__"